import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './SCSS/main.scss';
import Axios from "axios";

if (localStorage.getItem('token')) {
  Axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
}
ReactDOM.render(<App/>, document.getElementById('root'));
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
